(() => {
  "use strict";

  function task_2000() {
    function shouldRun() {
      const allowedUrls = [
        "/pages/immortelle-reset-collection",
        "/collections/anti-aging",
        "/pages/skin-care",
        "/collections/serums-oil-treatments",
        "/collections/skincare-sensitive-skin",
      ];

      // Extract the path part of the current URL
      const currentPath = window.location.pathname;

      return allowedUrls.includes(currentPath);
    }

    if (!shouldRun()) {
      console.log("not running");
      return;
    }

    function style() {
      const style = document.createElement("style");
      style.textContent = `
      .convx__campaign-test {
          position: fixed;
          top: 0;
          width: 100%;
          z-index: 99999999999;
          background: white;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          justify-content: space-evenly;
          align-items: center;
          padding: 20px 40px;
          transition: transform 0.3s ease-in-out;
          box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75);
      }
      .convx__campaign-test img {
          max-width: 150px;
      }
      .convx__campaign-test-c1 {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          justify-content: center;
          align-items: center;
      }
      .convx__campaign-test-c3 {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
      }
      .convx__campaign-test-c3 .btn {
          min-width: 200px;
          font-size:18px;
      }
      .convx__campaign-test-c1 > div {
          max-width: 350px;
      }
      
      .convx__campaign-test-c2 .list-2 {
          display: none;
      }
      
      @media screen and (max-width: 768px) {
          .convx__campaign-test {
              bottom: 0;
              top: auto;
              flex-direction: column;
              padding: 20px 20px;
              justify-content: center;
              transform: translateY(100%);
              padding-top: 5px;
          }
          .convx__campaign-test.open {
              transform: translateY(0);
          }
          .convx__campaign-test-c2 .list-1 {
              display: none;
          }
          .convx__campaign-test-c2 .list-2 {
              display: flex;
              list-style-type: none;
              width: 100%;
              justify-content: space-evenly;
              align-items: flex-start;
          }
          .convx__campaign-test-c2 .circle {
              width: 55px;
              height: 55px;
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 30px;
              background: #ffcb00;
              font-weight: bold;
          }
          .convx__campaign-test-c2 {
              width: 100%;
              display: flex;
              justify-content: space-evenly;
              align-items: center;
          }
      
          .convx__campaign-test-c2 .list-2 .list {
              display: flex;
              flex-direction: column;
              align-items: center;
              max-width: 100px;
              text-align: center;
              justify-content: flex-start;
          }
      
          .convx__campaign-test-c3 .btn {
              min-width: unset;
              width: 100%;
              height: 40px;
              font-size:18px;
          }
          .convx__campaign-test-c3 {
              width: 100%;
          }
          .convx__campaign-test {
              gap: 15px;
          }
      
          .convx__campaign-test-toggle {
              position: fixed;
              bottom: 0;
              width: 100%;
              background: #ffcb00;
              color: white;
              padding: 10px 0;
              text-align: center;
              font-size: 18px;
              cursor: pointer;
              z-index: 99999999;
          }
      
          .convx__campaign-test-close-bar, .convx__campaign-test-open-bar {
              width: 40px;
              height: 5px;
              background: gray;
              border-radius: 5px;
              margin: 10px auto;
          }
      
          .convx__campaign-test-close {
              width: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;
          }
          `;

      document.head.append(style);
    }

    function getVisitorCount() {
      const lastVisit = localStorage.getItem("lastVisit");
      const now = new Date().getTime();

      if (lastVisit && now - lastVisit < 3600000) {
        // 1 hour in milliseconds
        const remainingTime = 3600000 - (now - lastVisit);
        const minutesRemaining = Math.ceil(remainingTime / 60000);
        console.log(
          `%cVisitor count will reset in approximately ${minutesRemaining} minutes.`,
          "color: #A3DE2D; font-weight: bold;"
        );
        console.log(
          `%cLast visit was at ${new Date(
            parseInt(lastVisit, 10)
          ).toLocaleString()}.`,
          "color: #A3DE2D; font-weight: bold;"
        );
        return parseInt(localStorage.getItem("visitorCount"), 10);
      } else {
        const newCount = generatePersonCount();
        localStorage.setItem("visitorCount", newCount);
        localStorage.setItem("lastVisit", now);
        console.log(
          "%cVisitor count has been updated.",
          "color: #A3DE2D; font-weight: bold;"
        );
        console.log(
          `%cLast visit was at ${new Date(now).toLocaleString()}.`,
          "color: #A3DE2D; font-weight: bold;"
        );
        return newCount;
      }
    }

    function generatePersonCount() {
      return Math.floor(Math.random() * (250 - 150 + 1)) + 150;
    }

    style();

    const visitorCount = getVisitorCount();

    const immortelle = `
        <div class="convx__campaign-test-close">
            <div class="convx__campaign-test-close-bar"></div>
        </div>
        <div class="convx__campaign-test-c1">
            <img src="https://my.loccitane.com/cdn/shop/files/1200_PNG-27OR030I24_RVB_1800x1800.png?v=1725201706&width=300">
            <div>
                <b class="product-label"><p class="product-label">NEW FORMULA | +40% More Glow</p></b>
                <h2 class="martel h1">Immortelle Overnight Reset Oil-in-Serum</h2>
                <div class="martel "><span>30ml |<span class="money">RM298.00</span></span></div>
            </div>
        </div>
        <div class="convx__campaign-test-c2">
            <ul class="list-1">
                <li>Stronger Glow +</li>
                <li>More Revitalized +</li>
                <li>Better Hydration +</li>
            </ul>
            <div class="list-2">
                <div class="list"><div class="circle">+40%</div><span>NEW +40% MORE GLOW</span></div>
                <div class="list"><div class="circle">+31%</div><span>Better Hydration</span></div>
                <div class="list"><div class="circle">9/10</div><span>agreed skin is revitalized*</span></div>
            </div>
        </div>
        <div class="convx__campaign-test-c3">
            <div><i><span class="visitor-count">${visitorCount}</span> visitors viewed this item in the last hour!</i></div>
            <a class="btn" href="/products/immortelle-overnight-reset-oil-in-serum">I Want This!</a>
        </div>
      `;

    const campaignContainer = document.createElement("div");
    campaignContainer.classList.add("convx__campaign-test", "open");
    campaignContainer.innerHTML = immortelle;

    document.body.append(campaignContainer);

    const toggleButton = document.createElement("div");
    toggleButton.classList.add("convx__campaign-test-toggle");
    toggleButton.innerHTML = `<div class="convx__campaign-test-open-bar"></div>`;
    document.body.append(toggleButton);

    // Mobile drawer functionality
    toggleButton.addEventListener("click", () => {
      campaignContainer.classList.toggle("open");
    });

    // Swipe detection
    let startY = 0;

    campaignContainer.addEventListener("touchstart", (e) => {
      startY = e.touches[0].clientY;
    });

    campaignContainer.addEventListener("touchmove", (e) => {
      const moveY = e.touches[0].clientY;
      const diffY = moveY - startY;

      // Detect downward swipe (to close)
      if (diffY > 50) {
        campaignContainer.classList.remove("open");
      }
    });

    // Swipe up to open
    toggleButton.addEventListener("touchstart", (e) => {
      startY = e.touches[0].clientY;
    });

    toggleButton.addEventListener("touchmove", (e) => {
      const moveY = e.touches[0].clientY;
      const diffY = moveY - startY;

      // Detect upward swipe (positive value for upward swipe)
      if (diffY < -50) {
        campaignContainer.classList.add("open");
      }
    });

    // Close drawer with close bar
    const closeBar = campaignContainer.querySelector(
      ".convx__campaign-test-close"
    );
    closeBar.addEventListener("click", () => {
      campaignContainer.classList.remove("open");
    });
  }



  function globalOffer() {
    
    console.log("global offer init");
    
    const sideDrawer = document.querySelector('.convx__side-drawer')
    const overlay = document.querySelector(".convx__overlay");
    const closeDrawerBtn = document.querySelector(".convx__side-drawer .close-btn");


    // Create button to open drawer
    const openDrawerBtn = document.createElement("button");
    openDrawerBtn.id = "openDrawerBtn";
    openDrawerBtn.className += " site-nav__link site-nav__link--icon js-no-transition help-link";
    openDrawerBtn.innerHTML  = `<span style="margin-right: 5px; color:#C90B4A;" class="icon__fallback-text small--hide">OFFERS</span> <svg xmlns="http://www.w3.org/2000/svg" class="svg-icon" style="width: 2em;height: 2em;vertical-align: middle;fill: #C90B4A;overflow: hidden;transform: scaleX(-1);" viewBox="0 0 1024 1024" version="1.1"><path d="M384 977.152c-20.5312 0-39.8336-7.9872-54.3232-22.4256l-260.4032-260.4032c-14.4896-14.4896-22.4256-33.7408-22.4256-54.3232s7.9872-39.8336 22.4256-54.3232l439.6032-439.6032c24.9344-24.9344 70.2464-43.7248 105.5232-43.7248h230.4c42.3424 0 76.8 34.4576 76.8 76.8v230.4c0 35.2256-18.7904 80.5888-43.6736 105.5232l-439.6032 439.6032a76.1856 76.1856 0 0 1-54.3232 22.4256zM614.4 153.6c-21.248 0-54.272 13.6704-69.2736 28.7232l-439.6032 439.6032c-4.8128 4.8128-7.424 11.2128-7.424 18.1248s2.6624 13.312 7.424 18.0736l260.4032 260.4032c4.8128 4.8128 11.2128 7.424 18.1248 7.424s13.312-2.6624 18.1248-7.424l439.6032-439.6032c15.0016-15.0016 28.7232-48.0768 28.7232-69.3248V179.2a25.6 25.6 0 0 0-25.6-25.6h-230.4z" fill=""/><path d="M742.4 358.4c-42.3424 0-76.8-34.4576-76.8-76.8S700.0576 204.8 742.4 204.8s76.8 34.4576 76.8 76.8S784.7424 358.4 742.4 358.4z m0-102.4a25.6 25.6 0 1 0 0 51.2 25.6 25.6 0 0 0 0-51.2z" fill=""/></svg>`;
    
    if (window.innerWidth < 480) {
    document.querySelector('.header-item.header-item--left.header-item--navigation .site-nav.small-up--hide').after(openDrawerBtn);

    } else {
    document.querySelector('.site-nav__link[href="/pages/contact-us"]').before(openDrawerBtn);

    }


    // Function to toggle drawer and overlay
    function toggleDrawer() {
    const isOpen = sideDrawer.classList.toggle("open");
    overlay.classList.toggle("show", isOpen);
    }

    // Event listener for toggling the drawer (open/close)
    openDrawerBtn.addEventListener("click", toggleDrawer);

    // Event listener for closing the drawer via close button
    closeDrawerBtn.addEventListener("click", toggleDrawer);

    // Close the drawer if overlay is clicked
    overlay.addEventListener("click", toggleDrawer);

    
}


  function onDOMContentLoaded() {
    const path = location.pathname;
    const isHomePage = path == "/";
    const isProducts = path.includes("/products");
    const isCollections = path.includes("/collections") && !isProducts;
    const isCart = path == "/cart";

    // task_2000();

    globalOffer()
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onDOMContentLoaded, {
      once: true,
    });
  } else {
    onDOMContentLoaded();
  }
})();
